import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import CustomFormView from '../../../../../shared/custom-form-view/Custom-Form-View';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../../../utils/formUtils';
import { TELEPHONY_DIRECTORY_ICON_OPTIONS } from '../../../../../constants/ServiceConstants';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { fetchAllTelephonyDetails } from '../../../servicesSlice';
import {
  createTelephonyDirectories,
  updateTelephonyDirectories,
} from '../../../../../utils/ServicesAPIUtils';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const DirecoryCreate = (props) => {
  const { toggleDrawer, directoriesObj, hotelId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    extensionNumber: {
      value: '',
      fieldName: 'Extension Number',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    extensionPassword: {
      value: '',
      fieldName: 'Password',
      errors: {},
      validations: ['validPureAlphaNumeric'],
      tab: 0,
    },
    icon: {
      value: '',
      fieldName: 'Icon',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 0,
    },
    isActive: {
      value: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    if (directoriesObj) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = directoriesObj[field];
      }
      setFormData(currFields);
    }
  }, [directoriesObj]);

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  const onCancel = () => {
    toggleDrawer('', false, '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(stepUpLoaderCount());
      toggleDrawer('', false, '');
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      let payload = {
        hotelId,
        name: formData.name.value,
        code: formData.code.value,
        extensionNumber: formData.extensionNumber.value,
        extensionPassword: formData.extensionPassword.value,
        icon: formData.icon.value,
        description: formData.description.value,
        isActive: formData.isActive.value,
      };
      if (directoriesObj?.id) {
        payload.id = directoriesObj.id;
        await updateTelephonyDirectories(payload, language);
        notificationManager('success', 'Directory updated successfully');
      } else {
        await createTelephonyDirectories(payload, language);
        notificationManager('success', 'Directory created successfully');
      }
      dispatch(fetchAllTelephonyDetails(hotelId));
      setLoading(false);
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors
          ? error?.graphQLErrors[0]?.message
          : 'Error occurred while creating directory',
      );
      setLoading(false);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onChangeNumber = (e) => {
    const value = e?.value?.toString() || '';
    const re = /^[0-9\b]+$/;
    if (value.length === 0) setFormData({ extensionNumber: e });
    else if (value.length <= 6 && re.test(value)) setFormData({ extensionNumber: e });
  };

  return (
    <CustomFormView
      handleSubmit={handleSubmit}
      tabTitle={[]}
      onCancel={onCancel}
      tabValue={0}
      maxtab={0}
      isTabInValid={isTabInValid}
      isUpdate={directoriesObj ? true : false}
      loading={loading}
      title={`${directoriesObj ? 'Edit' : 'Add'} Number`}
      titleClass='col-md-10'
      cancelClass='col-md-2'
    >
      <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
        <div className='col-md-12 mb-3'>
          <h4 className='tab-title'>Details</h4>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
                maxLength={6}
                endAdornment={true}
                characterCount={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.extensionNumber}
                type='number'
                min={0}
                maxLength={6}
                handleInputChange={(e) => onChangeNumber(e)}
                endAdornment={true}
                characterCount={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.extensionPassword}
                handleInputChange={(e) => {
                  setFormData({ extensionPassword: e });
                }}
                maxLength={8}
                endAdornment={true}
                characterCount={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomSelect
                hideNullOption={true}
                item={formData.icon}
                handleInputChange={(e) => {
                  setFormData({ icon: e });
                }}
                options={TELEPHONY_DIRECTORY_ICON_OPTIONS}
                labelPrefix='Select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData.description}
                handleInputChange={(e) => {
                  setFormData({ description: e });
                }}
                multiline={true}
              />
            </div>
          </div>
          <div className='row w-100 mt-2' style={{ display: 'flex', alignItems: 'center' }}>
            <div className='col-auto' style={{ display: 'flex', alignItems: 'center' }}>
              <CustomCheckbox
                item={formData.isActive}
                handleInputChange={(e) => 
                  setFormData({ isActive: e })
                }
                color='primary'
              />
              <Tooltip title='Deactivating a number hides it from Guest app' placement='right-end'>
                <InfoIcon fontSize='small'
                  style={{ marginLeft: 6, display: 'inline-flex', verticalAlign: 'middle' }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    </CustomFormView>
  );
};

export default DirecoryCreate;
